<template>
    <div @click="closeFilters()" class="filters-page" :class="isSticking ? 'sticky' : ''">
        <div v-on:click.stop class="filters-page-container">
            <div class="filter-header">
                <p>Sort By</p>
                <img @click="closeFilters()" class="x" src="https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652" alt="x"/>
            </div>
            <div class="filters-container">
                <div class="radio-container">
                    <input type="radio" id="Recommended" v-model="selectedSortMobile" value="1" />
                    <label for="Recommended">Recommended</label>
                </div>
                <div class="radio-container">
                    <input type="radio" id="Pricelh" v-model="selectedSortMobile" value="4" />
                    <label for="Pricelh">Price Low to High</label>
                </div>
                <div class="radio-container">
                    <input type="radio" id="Pricehl" v-model="selectedSortMobile" value="5" />
                    <label for="Pricehl">Price High to Low</label>
                </div>
                <div class="radio-container">
                    <input type="radio" id="Stockhl" v-model="selectedSortMobile" value="6" />
                    <label for="Stockhl">Stock High to Low</label>
                </div>
            </div>
            <div class="button-container">
                <button @click="resetFilters" class="happybox-button white border">Reset</button>
                <button @click="applyFilters" class="happybox-button green border">Apply</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    components: {
    },
    data() {
        return{
        }
    },
    props:{
        isSticking: Boolean
    },
    computed: {
        ...mapGetters([
            //True filters Start
            'selectedSort',
            //True filters END
        ]),
        selectedSortMobile: {
            get(){ return this.$store.state.selectedSortMobile},
            set(value){this.$store.commit('setSelectedSortMobile', value )}
        },
    },
    methods: {
        closeFilters(){
            //Reset the mobile filters to the true filters
            this.selectedSortMobile = this.selectedSort;
            this.$emit("closefilter");
        },
        resetFilters(){
            this.$store.commit('setSelectedSort', 1 )
            this.closeFilters();
        },
        applyFilters(){
            //Change the mobile filters to the true filters
            this.logFilters();
            this.$store.commit('setSelectedSort', this.selectedSortMobile );
            this.$emit("closefilter");
        },
        logFilters(){
            ga('send', {
                hitType: 'event',
                eventCategory: 'Build A Box',
                eventAction: 'Filter Occasion',
                eventLabel: this.selectedOccasionMobile
            });
            ga('send', {
                hitType: 'event',
                eventCategory: 'Build A Box',
                eventAction: 'Filter Category',
                eventLabel: this.selectedCategoriesMobile
            });
            for(let filter in this.selectedFiltersMobile){
                ga('send', {
                    hitType: 'event',
                    eventCategory: 'Build A Box',
                    eventAction: `Filter ${filter.title}`,
                    eventLabel: filter.filters
                });
            }
        }
    }
}
</script>

<style scoped>
.filters-page{
    width: 100%;
    height: 100%;
    position: fixed;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 5;
    transition: height 0.5s;
    display: flex;
    justify-content: flex-end;
}
.filters-page-container{
    width: 75%;
    max-height: 100%;
    min-height: 100%;
    height: 100%;
    background-color: white;
    overflow-y: scroll;
    padding-bottom: 17%;
}

.filters-container{
    padding: 5%;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.filter-header{
    box-shadow: inset 0px -1px 0px #e6e8ec;
    display: flex;
    padding: 5%;
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 1;
    justify-content: space-between;
    align-items: center;
}

.filter-header p{
    font-weight: 700;
    font-size: 20px;
    line-height: 32px;
    color: #000000;
}

.filter-header button{
    font-size: 25px;
    line-height: 1;
    color: black;
    padding-right: 5%;
    z-index: 1;
}

.button-container{
    width: 75%;
    position: absolute;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: space-around;
    box-shadow: inset 0px 1px 0px #E6E8EC;
    padding: 3% 0%;
    background-color: white;
    z-index: 1;
}

.button-container button{
    width: 44%;
}

.x{
    width: 20px;
    cursor: pointer;
}

.radio-container{
    width: 100%;
    display: flex;
}

.radio-container input{
    height: unset !important;
}

.radio-container label{
    font-size: 1.3vw;
    font-weight: bold;
    font-family: 'Karla',sans-serif;
    color: #0F0C38;
}

@media screen and (min-width: 768px){
    .filters-page{
        justify-content: flex-start;
    }

    .filters-page-container{
        width: 20%;
    }

    .button-container{
        right: unset;
        width: 20%;
        left: 0;
    }
}

@media screen and (max-width: 768px){
    .radio-container label{
        font-size: 1rem;
    }

    .filters-page{
        height: 100%;
    }

    .sticky.filters-page{
        height: calc(100% - 88px);
    }
}
</style>